import React from 'react';

const ThumbnailImage = props => {
  let imageUrl = props.imageUrl;
  let imageAlt = props.imageAlt;
  let elemIndex = props.elemIndex || 0;
  return (
    <div
      data-element-index={elemIndex}
      onClick={props.onThumbnailClick}
      key={elemIndex}
      className="gallery-element-wrapper"
      style={{ backgroundImage: `url(${imageUrl})` }}
      title={imageAlt}
    />
  );
};

export default ThumbnailImage;



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/gallery/thumbnail_image.jsx